/* 🤖 this file was generated by script */
export const wiconFile06 = {
  name: 'file_06',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 2.27V6.4c0 .56 0 .84.1 1.05a1 1 0 00.45.44c.21.11.49.11 1.05.11h4.13M16 13H8m8 4H8m2-8H8m6-7H8.8c-1.68 0-2.52 0-3.16.33a3 3 0 00-1.31 1.3C4 4.29 4 5.13 4 6.8v10.4c0 1.68 0 2.52.33 3.16a3 3 0 001.3 1.31c.65.33 1.49.33 3.17.33h6.4c1.68 0 2.52 0 3.16-.33a3 3 0 001.31-1.3c.33-.65.33-1.49.33-3.17V8l-6-6z"/></svg>`,
};
